import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { fg } from '@atlaskit/platform-feature-flags';
import { segmentUnmountCache } from '../../interaction-metrics';
import { optimizeLabelStack, stringifyLabelStackFully } from '../common/utils';
export function optimizeReactProfilerTimings(reactProfilerTimings, interactionStart, reactUFOVersion) {
  var reactProfilerTimingsMap = reactProfilerTimings.reduce(function (result, _ref) {
    var labelStack = _ref.labelStack,
      startTime = _ref.startTime,
      commitTime = _ref.commitTime,
      actualDuration = _ref.actualDuration,
      type = _ref.type;
    if (labelStack && startTime >= interactionStart) {
      var label = stringifyLabelStackFully(labelStack);
      var start = Math.round(startTime);
      var end = Math.round(commitTime);
      var timing = result.get(label) || {
        labelStack: optimizeLabelStack(labelStack, reactUFOVersion),
        startTime: start,
        endTime: end,
        mountCount: 0,
        rerenderCount: 0,
        renderDuration: 0
      };
      if (start < timing.startTime) {
        timing.startTime = start;
      }
      if (end > timing.endTime) {
        timing.endTime = end;
      }
      if (type === 'mount') {
        timing.mountCount += 1;
      }
      if (type === 'update') {
        timing.rerenderCount += 1;
      }
      if (segmentUnmountCache.has(label) && fg('platform_ufo_segment_unmount_count')) {
        timing.unmountCount = segmentUnmountCache.get(label) || 0;
        segmentUnmountCache.delete(label);
      }
      timing.renderDuration += Math.round(actualDuration);
      result.set(label, timing);
    }
    return result;
  }, new Map());
  return _toConsumableArray(reactProfilerTimingsMap.values());
}